import { HTTPService } from './httpService';

const API = new HTTPService();

const ColorSettingsAPI = {
  /**
   * Fetch color settings for an installer (stage_colors, calendar_color_mode).
   */
  getColorSettings: async (installerId) => {
    const response = await API.get(`/installer-settings/${installerId}/colors`);
    return response.data;
  },

  /**
   * Update color settings (stage_colors object and/or calendar_color_mode).
   */
  updateColorSettings: async (installerId, payload) => {
    const response = await API.patch(`/installer-settings/${installerId}/colors`, payload);
    return response.data;
  },

  /**
   * Update a user's color assignment.
   */
  updateUserColor: async (userId, color) => {
    const response = await API.patch(`/users/${userId}/color`, { user_color: color });
    return response.data;
  },
};

export default ColorSettingsAPI;
